import { useState, useEffect, useMemo, useRef } from 'react';
import { useSearchAdornment } from '../../Adornment';
import { variantPreFilter, containsFocus } from '../utils';
import { useDebounce } from '../../../../tools/utils';
export const useInputSelectState = ({ variant, options, inputWrapperRef, inputValue, minSearchChars, maxDisplayedOptions, isLoading, }) => {
    const staticPrevInputValue = useRef('');
    const filteredOptions = useMemo(() => {
        const variantOptions = variantPreFilter(variant, options);
        return variantOptions.length > maxDisplayedOptions
            ? variantOptions.slice(0, maxDisplayedOptions)
            : variantOptions;
    }, [variant, maxDisplayedOptions, options]);
    const [isMounted, setMounted] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const { setClickCallback } = useSearchAdornment();
    // debouncing to give options a chance to update after load complete
    const { handleValueChange: debounceShowLoading } = useDebounce({
        debounceTimeout: 100,
        onDebounced: setShowLoading,
    });
    useEffect(() => {
        setMounted(true);
        // sets the click callback for the search adornment button
        setClickCallback(() => setShowOptions(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (containsFocus(inputWrapperRef) &&
            inputValue.length >= minSearchChars &&
            showLoading !== isLoading) {
            if (showLoading)
                debounceShowLoading(false);
            else
                setShowLoading(true);
        }
        // do not add showLoading to the dependency array
        // we don't want to update based on the state we're setting
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, inputValue, minSearchChars]);
    useEffect(() => {
        const prevValue = staticPrevInputValue.current;
        if (inputValue.length < minSearchChars) {
            if (showOptions)
                setShowOptions(false);
            if (showLoading)
                setShowLoading(false);
        }
        else if (containsFocus(inputWrapperRef) &&
            prevValue.length !== inputValue.length) {
            if (!showOptions)
                setShowOptions(true);
        }
        if (prevValue !== inputValue) {
            staticPrevInputValue.current = inputValue;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minSearchChars, inputValue]);
    return {
        filteredOptions,
        showOptions,
        showLoading,
        setShowOptions,
        setShowLoading,
        isMounted,
    };
};
//# sourceMappingURL=useInputSelectState.js.map